import * as React from 'react';
import { DeviceEncryptionAlert } from '../../../misc/components/DeviceEncryptionAlert';

declare const rootUrl: string;

interface VitaloJak2ConnectionStepsProps {
    onBack: () => void;
    onNext: () => void;

}

export const VitaloJak2ConnectionSteps = ({ onBack, onNext }: VitaloJak2ConnectionStepsProps) => {
    return (
        <>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="text-primary">Connect Device to PC</h2>
                        <DeviceEncryptionAlert show={true} />
                    </div>
                    <div className="col-md-12">
                        <ol className="posh-list">
                            <li>Remove the back cover of the device using the screwdriver provided, remove any battery pack if present</li>
                            <li>Unplug the sensor and microphone connector from the device if present</li>
                            <li>Plug the data cable into the device then connect to a USB port on your PC</li>
                        </ol>
                    </div>
                    <div className="col-md-12 text-center">
                        <img style={{ width: '100%', maxWidth: '298px' }} src={rootUrl + '/Images/Wizards/vitalojak2-1.png'} alt="" />
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={onNext}>Next</button>
                <button className="btn btn-primary btn-outline" onClick={onBack}>Back</button>
            </div>
        </>
    );
}
